import React, { useEffect, useState } from 'react'
import Slider from "react-slick";
import { ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import Card_1 from '../components/Card_1';
import Card_2 from '../components/Card_2';
import Header from '../components/Header'
import MobileNav from '../components/MobileNav';

import CategorySkeleton from '../components/CategorySkeleton'
import Card2Skeleton from '../components/Card2Skeleton'

export default function Home() {
    const navigate = useNavigate();

    const [categories, setCategories] = useState([]);
    const [tvChannels, setTvChannels] = useState([]);
    const [loading, setLoading] = useState(false);
    const [randomIndex, setrandomIndex] = useState();

    const [visibleCount, setVisibleCount] = useState(3);

    const handleLoadMore = () => {
        setVisibleCount((prev) => prev + 3); // load 3 more each time
    };

    useEffect(() => {
        setrandomIndex(Math.floor(Math.random() * 4) + 1);
        async function fetchData() {
            setLoading(true);

            try {
                // Check for Laki content
                const cachedContent = JSON.parse(sessionStorage.getItem("Laki_content"));
                if (cachedContent) {
                    console.log("Using cached Laki content");
                    setCategories(cachedContent);
                } else {
                    console.log("No cached Laki content, fetching...");
                    const contentRes = await fetch(`https://apiv2.mobileartsme.com/laki_getcontent?apisource=0&TransactionID=c93f5114-bcf1-4184-b5bf-14a7db655b92&HashSignature=8ac35c949d5ce2d5c0e77b7e829689be&phonenumber=96170932819&ClientKey=b922306c-aa5f-4024-804a-7ed06f4d0a3b&ispremium=true&language=en&country=`);
                    const contentData = await contentRes.json();

                    if (contentData?.Content?.[0]?.Videos) {
                        sessionStorage.setItem("Laki_content", JSON.stringify(contentData.Content[0].Videos));
                        setCategories(contentData.Content[0].Videos);
                    }
                }

                // Check for TV Channels
                const cachedTvChannels = JSON.parse(sessionStorage.getItem("tv_channels"));
                if (cachedTvChannels) {
                    console.log("Using cached TV channels");
                    setTvChannels(cachedTvChannels);
                } else {
                    console.log("No cached TV channels, fetching...");
                    const tvRes = await fetch('https://apiv2.mobileartsme.com/laki_tvchannels');
                    const tvData = await tvRes.json();

                    sessionStorage.setItem("tv_channels", JSON.stringify(tvData.Channels));
                    setTvChannels(tvData.Channels);
                }

            } catch (error) {
                console.error("Error fetching data", error);
            } finally {
                setLoading(false);
            }
        }

        fetchData();
    }, []);



    var settings = {
        arrows: false,
        dots: false,
        infinite: false,
        autoplay: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 3,
        gap: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    };




    function getTwoUniqueRandomIndexes(max) {
        const first = Math.floor(Math.random() * max);
        let second;
        do {
            second = Math.floor(Math.random() * max);
        } while (second === first);
        return [first, second];
    }



    return (
        <div>
            <Header categories={categories} />

            <section className='container py-1' >
                {loading ? (
                    <Card2Skeleton rows={2} />
                ) : categories.length > 0 && categories[0]?.Content?.length > 1 && categories[randomIndex]?.Content?.length > 0 ? (
                    <>
                        {(() => {
                            const [leftIndex, rightIndex] = getTwoUniqueRandomIndexes(3);
                            return (
                                <div className='row'>
                                    <h2 className='pink' >Popular Videos</h2>
                                    <div className='col-lg-5 col-6 mb-3'>
                                        <Card_2
                                            video={categories[randomIndex].Content[leftIndex]}
                                            channel={categories[randomIndex]}
                                            key={"left-random-1"}
                                        />
                                    </div>
                                    <div className='col-lg-7 col-6 mb-3'>
                                        <Card_2
                                            video={categories[randomIndex].Content[rightIndex]}
                                            channel={categories[randomIndex]}
                                            key={"right-random-1"}
                                        />
                                    </div>
                                </div>
                            );
                        })()}


                        {(() => {
                            const [leftIndex, rightIndex] = getTwoUniqueRandomIndexes(3);
                            return (
                                <div className='row py-2'>
                                    <div className='col-lg-7 col-6'>
                                        <Card_2
                                            video={categories[0].Content[leftIndex]}
                                            channel={categories[2]}
                                            key={"left-random-2"}
                                        />
                                    </div>
                                    <div className='col-lg-5 col-6'>
                                        <Card_2
                                            video={categories[2].Content[rightIndex]}
                                            channel={categories[2]}
                                            key={"right-random-2"}
                                        />
                                    </div>
                                </div>
                            );
                        })()}
                    </>
                ) : (
                    <p>No data available.</p>
                )}

                {/* <Card2Skeleton rows={2} /> */}
            </section>


            <section className='container my-5' >
                <h2 className='pink' >Live Channels</h2>
                <Slider {...settings}>
                    {tvChannels.map((channel, index) => (
                        <img src={channel.ChannelThumbnail} style={{ maxHeight: '10rem' }} onClick={() => navigate("/live", { state: { tvChannels, channel } })} />
                    ))}
                </Slider>

            </section>


            <section className='container' style={{ marginBottom: '6rem' }}>
                {loading ? <CategorySkeleton count={3} /> : (
                    <>
                        {categories.slice(0, visibleCount).map((categorie, index) => (
                            <div key={index} id={`category_${categorie.Name}`} className='mb-5'>
                                <div className='d-flex flex-row justify-content-between'>
                                    <h2 className='pink'>{categorie.Name}</h2>

                                    <span
                                        className='text-light d-flex flex-row align-items-center'
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => navigate("/category", { state: { category: categorie } })}
                                    >
                                        View All <ChevronRight />
                                    </span>
                                </div>

                                <Slider {...settings}>
                                    {categorie.Content.slice(0, 10).map((video, VidIndex) => (
                                        <Card_1 video={video} channel={categorie.Content} key={VidIndex} />
                                    ))}
                                </Slider>
                            </div>
                        ))}

                        {visibleCount < categories.length && (
                            <div className='d-flex flex-row align-items-center justify-content-center w-100 mb-5'>
                                <button className='btn btn-primary' onClick={handleLoadMore}>
                                    Load More
                                </button>
                            </div>
                        )}
                    </>
                )}
            </section>


            <MobileNav categories={categories} />

        </div>
    )
}
